/* Softember — scripts propios */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.sf-reveal:not(.sf-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('sf-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('sf-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initGallery(root) {
    var main = root.querySelector('[data-sf-main]');
    var thumbs = root.querySelectorAll('[data-sf-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        main.src = btn.getAttribute('data-src');
        main.srcset = '';
        main.alt = btn.getAttribute('data-alt') || '';
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
  }

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    return (format || '${{amount}}')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount\s*\}\}/, withCommas);
  }

  function initProduct(root) {
    var dataEl = root.querySelector('[data-sf-variants]');
    var form = root.querySelector('form[action*="/cart/add"]');
    if (!dataEl || !form) return;
    var variants = JSON.parse(dataEl.textContent);
    var moneyFormat = root.getAttribute('data-money-format');
    var idInput = form.querySelector('input[name="id"]');
    var priceNow = root.querySelector('[data-sf-price]');
    var priceWas = root.querySelector('[data-sf-compare]');
    var save = root.querySelector('[data-sf-save]');
    var button = form.querySelector('[data-sf-add]');
    var addLabel = button ? button.getAttribute('data-label-add') : '';
    var soldLabel = button ? button.getAttribute('data-label-sold') : '';
    var error = root.querySelector('[data-sf-error]');

    function selectedOptions() {
      var fieldsets = root.querySelectorAll('[data-sf-option]');
      return Array.prototype.map.call(fieldsets, function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    var bundles = root.querySelector('[data-sf-bundles]');
    var qtyInput = root.querySelector('[data-sf-qty-input]');
    var stickyPrice = root.querySelector('[data-sf-sticky-price]');

    function updateBundles(price) {
      if (!bundles) return;
      bundles.querySelectorAll('input[data-qty]').forEach(function (input) {
        var qty = parseInt(input.getAttribute('data-qty'), 10);
        var pct = parseInt(input.getAttribute('data-pct'), 10) || 0;
        var box = input.closest('.sf-bundle');
        var full = price * qty;
        var total = (price - Math.floor(price * pct / 100)) * qty;
        var now = box.querySelector('[data-sf-bundle-now]');
        var was = box.querySelector('[data-sf-bundle-was]');
        if (now) now.textContent = formatMoney(total, moneyFormat);
        if (was) was.textContent = formatMoney(full, moneyFormat);
      });
    }

    function selectedBundleTotal() {
      if (!bundles) return null;
      var checked = bundles.querySelector('input:checked');
      var now = checked && checked.closest('.sf-bundle').querySelector('[data-sf-bundle-now]');
      return now ? now.textContent : null;
    }

    if (bundles) {
      var fromUrl = new URLSearchParams(window.location.search).get('qty');
      if (fromUrl) {
        var pre = bundles.querySelector('input[data-qty="' + fromUrl + '"]');
        if (pre) pre.checked = true;
      }
      var syncQty = function () {
        var checked = bundles.querySelector('input:checked');
        if (checked && qtyInput) qtyInput.value = checked.getAttribute('data-qty');
        var t = selectedBundleTotal();
        if (t && stickyPrice) stickyPrice.textContent = t;
      };
      bundles.querySelectorAll('input').forEach(function (i) { i.addEventListener('change', syncQty); });
      syncQty();
    }

    function update() {
      var opts = selectedOptions();
      var variant = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!variant) return;
      idInput.value = variant.id;
      updateBundles(variant.price);
      if (bundles) bundles.hidden = !variant.available;
      if (stickyPrice) stickyPrice.textContent = selectedBundleTotal() || formatMoney(variant.price, moneyFormat);
      if (priceNow) priceNow.textContent = formatMoney(variant.price, moneyFormat);
      var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (priceWas) {
        priceWas.textContent = hasCompare ? formatMoney(variant.compare_at_price, moneyFormat) : '';
        priceWas.hidden = !hasCompare;
      }
      if (save) {
        save.hidden = !hasCompare;
        if (hasCompare) save.textContent = save.getAttribute('data-template').replace('[amount]', formatMoney(variant.compare_at_price - variant.price, moneyFormat));
      }
      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available ? addLabel : soldLabel;
      }
      if (variant.featured_media && root.querySelector('[data-sf-thumb][data-media-id="' + variant.featured_media.id + '"]')) {
        root.querySelector('[data-sf-thumb][data-media-id="' + variant.featured_media.id + '"]').click();
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    root.querySelectorAll('[data-sf-option] input').forEach(function (input) {
      input.addEventListener('change', update);
    });

    var qty = root.querySelector('[data-sf-qty]');
    if (qty) {
      var input = qty.querySelector('input');
      qty.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = parseInt(input.value, 10) || 1;
          n = b.getAttribute('data-step') === '-1' ? Math.max(1, n - 1) : n + 1;
          input.value = n;
        });
      });
    }

    /* Añadir al carrito y abrir el cajón del carrito de Dawn si existe */
    form.addEventListener('submit', function (e) {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.renderContents !== 'function' || !window.fetch) return;
      e.preventDefault();
      if (error) error.textContent = '';
      button.disabled = true;
      var fd = new FormData(form);
      fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: fd
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) {
            if (error) error.textContent = res.description || res.message || '';
            return;
          }
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        })
        .catch(function () { form.submit(); })
        .finally(function () { button.disabled = false; });
    });
  }

  /* Fecha estimada de entrega: hoy + N días hábiles (sin sábados ni domingos) */
  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    while (days > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) days--;
    }
    return d;
  }

  function initDelivery(root) {
    var el = root.querySelector('[data-sf-delivery]');
    if (el) {
      var locale = el.getAttribute('data-locale') || 'en';
      var fmt = { month: 'short', day: 'numeric' };
      var now = new Date();
      var from = addBusinessDays(now, parseInt(el.getAttribute('data-min'), 10) || 8);
      var to = addBusinessDays(now, parseInt(el.getAttribute('data-max'), 10) || 15);
      el.querySelector('span').textContent = el.getAttribute('data-template')
        .replace('[from]', from.toLocaleDateString(locale, fmt))
        .replace('[to]', to.toLocaleDateString(locale, fmt));
    }
    var cut = root.querySelector('[data-sf-cutoff]');
    if (cut) {
      var parts = (cut.getAttribute('data-date') || '').split('-');
      if (parts.length === 3) {
        var limit = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10), 23, 59);
        var days = Math.ceil((limit - new Date()) / 86400000);
        if (days > 0 && days <= 75) {
          cut.querySelector('span').textContent = cut.getAttribute('data-template').replace('[days]', days);
          cut.hidden = false;
        }
      }
    }
  }

  /* Barra fija de compra: aparece cuando el botón principal sale de la pantalla */
  function initSticky(root) {
    var bar = root.querySelector('[data-sf-sticky]');
    var main = root.querySelector('[data-sf-add]');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    var btn = bar.querySelector('[data-sf-sticky-btn]');
    new IntersectionObserver(function (entries) {
      var show = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      btn.tabIndex = show ? 0 : -1;
    }).observe(main);
    btn.addEventListener('click', function () {
      if (main.disabled) {
        main.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        main.click();
      }
    });
  }

  /* Carrusel táctil (sección de momentos): flechas y puntos sincronizados con el deslizamiento */
  function initCarousels() {
    document.querySelectorAll('[data-sf-carousel]').forEach(function (car) {
      if (car.dataset.sfReady) return;
      car.dataset.sfReady = '1';
      var track = car.querySelector('[data-sf-track]');
      var prev = car.querySelector('[data-sf-prev]');
      var next = car.querySelector('[data-sf-next]');
      var dots = car.querySelectorAll('[data-sf-dots] button');
      if (!track) return;
      var items = track.children;
      function step() { return items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : track.clientWidth; }
      function current() { return Math.round(track.scrollLeft / (step() || 1)); }
      function go(i) {
        i = Math.max(0, Math.min(items.length - 1, i));
        track.scrollTo({ left: i * step(), behavior: reduce ? 'auto' : 'smooth' });
      }
      function sync() {
        var i = current();
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
      if (prev) prev.addEventListener('click', function () { go(current() - 1); });
      if (next) next.addEventListener('click', function () { go(current() + 1); });
      dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });
      var t;
      track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 60); }, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  function init() {
    initReveal();
    initCarousels();
    document.querySelectorAll('[data-sf-product]').forEach(function (root) {
      initGallery(root);
      initProduct(root);
      initDelivery(root);
      initSticky(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function () { initReveal(); initCarousels(); });
})();
